
function isDataURL(s) {
    return !!s.match(isDataURL.regex);
}

isDataURL.regex = /^\s*data:([a-z]+\/[a-z]+(;[a-z-]+=[a-z-]+)?)?(;base64)?,[a-z0-9!$&',()*+,;=\-._~:@/?%\s]*\s*$/i;


export default class PageModel {
  constructor(){
    this.picture = null;
    this.people = "";
    this.description = "";
  }

  isValidPicture(){
    return this.picture && isDataURL(this.picture);
  }


}
